import React, { useEffect, useState } from 'react';
import { Box, Grid2, Typography, Button, Grid, FormControl, Select, MenuItem, CircularProgress, CardContent, Dialog } from '@mui/material';
import HeaderBack from '../Header_Back';
import events2 from '../../assets/images/events_2.png';
import Minus from '../../assets/images/minus.svg';
import Plus from '../../assets/images/plus.svg';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'; 
import useRequests from "../../utils/useRequests";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Snackbars from "../../utils/Snackbars";
import { useFormik } from "formik";
import * as Yup from "yup";
import { format } from 'date-fns';
import buypriceSmall from "../../assets/images/buyprice-small.svg";
import banner from "../../assets/images/banner.png";
import BackImage from '../../assets/images/back.svg';
import LoginModal from "../components/LoginModal"; // Import the login modal

const Eventsticketbook = () => {
    const { e_id } = useParams();
    const location = useLocation();
    const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));
    const [showLoginModal, setShowLoginModal] = useState(false); // State for login modal
    const [loading, setLoading] = useState(true);
    const { getRequest, postRequest } = useRequests();
    const [AlertData, setAlertData] = React.useState({
        variant: "",
        message: ""
      });
      const resetAlertData = () => {
        setTimeout(() => {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: "",
            message: ""
          }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
      };
    
    const [open, setOpen] = useState(false);
      
    const [isProcessing, setIsProcessing] = useState(false);

    const formatEventDate = (start, end, time) => {

        const startDate = new Date(start);
        const endDate = new Date(end);
        const diffInMs = endDate - startDate; // Difference in milliseconds
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
        const day = `${diffInDays+1}`.toLowerCase();

        const startDay = format(startDate, 'dd');
        const endDay = format(endDate, 'dd');
        const month = format(startDate, 'MMMM');
        const year = format(startDate, 'yyyy');
        let daysCount = day;
        if(day>1){
            daysCount = "10";
        }
        
        return { formattedDate: `${startDay} - ${endDay} ${month}, ${year}`, daysCount: `${daysCount} Day's Event` , time };

    };
    

      const [value] = React.useState(null);
      const [quantity, setQuantity] = useState(1);
      const handleIncrement = () => { 
        setQuantity(quantity + 1); 
        setTicketPrice(Number((quantity + 1) * fixTicketAmount))
        let ticketamount;
        if(platform_fees_type == "Fixed"){
            ticketamount = Number((quantity + 1) * fixTicketAmount) + Number(platform_fees_fixed);
            setTicketAmount(Number((quantity + 1) * fixTicketAmount) + Number(platform_fees_fixed));
        }else{
            ticketamount = Number((quantity + 1) * fixTicketAmount) + Number((((quantity + 1) * fixTicketAmount)*platform_fees)/100);
            setTicketAmount(Number((quantity + 1) * fixTicketAmount) + Number((((quantity + 1) * fixTicketAmount)*platform_fees)/100));
        }
        let onlygst = 0;
        let onlytcs = 0;
        if(detail.gst == true){
            if(platform_fees_type == "Fixed"){
                setOnlyGst(Number(((platform_fees_fixed) * gst)/100))
                onlygst = Number(((platform_fees_fixed) * gst)/100)
            }else{
                setOnlyGst(Number(((((quantity + 1) * fixTicketAmount)*platform_fees)/100 * gst)/100))
                onlygst = Number(((((quantity + 1) * fixTicketAmount)*platform_fees)/100 * gst)/100)
            }
        }
        if(detail.tcs == true){
            setOnlyTcs(Number(((quantity + 1) * fixTicketAmount * tcs)/100))
            onlytcs = Number(((quantity + 1) * fixTicketAmount * tcs)/100)
        }
        setTicketAmount(ticketamount+onlygst+onlytcs)
        if(platform_fees_type == "Fixed"){
            setOnlyFees(Number(platform_fees_fixed));
        }else{
            setOnlyFees(Number((((quantity + 1) * fixTicketAmount)*platform_fees)/100));
        }
    };
      const handleDecrement = () => { 
            if (quantity > 1) {
             setQuantity(quantity - 1);
             setTicketPrice(Number((quantity - 1) * fixTicketAmount)) 
             let ticketamount;
             if(platform_fees_type == "Fixed"){
                ticketamount = Number((quantity - 1) * fixTicketAmount) + Number(platform_fees_fixed);
             }else{
                ticketamount = Number((quantity - 1) * fixTicketAmount) + Number((((quantity - 1) * fixTicketAmount)*platform_fees)/100);
             }
             let onlygst = 0;
             let onlytcs = 0;
             if(platform_fees_type == "Fixed"){
                setTicketAmount(Number((quantity - 1) * fixTicketAmount) + Number(platform_fees_fixed));
             }else{
                setTicketAmount(Number((quantity - 1) * fixTicketAmount) + Number((((quantity - 1) * fixTicketAmount)*platform_fees)/100));
             }
                if(detail.gst == true){
                    if(platform_fees_type == "Fixed"){ 
                        setOnlyGst(Number(((platform_fees_fixed) * gst)/100))
                        onlygst = Number(((platform_fees_fixed) * gst)/100)
                    }else{
                        setOnlyGst(Number(((((quantity - 1) * fixTicketAmount)*platform_fees)/100 * gst)/100))
                        onlygst = Number(((((quantity - 1) * fixTicketAmount)*platform_fees)/100 * gst)/100)
                    }
                }
                if(detail.tcs == true){
                    setOnlyTcs(Number(((quantity - 1) * fixTicketAmount * tcs)/100))
                    onlytcs = Number(((quantity - 1) * fixTicketAmount * tcs)/100)
                }
                setTicketAmount(ticketamount+onlygst+onlytcs)
                if(platform_fees_type == "Fixed"){
                    setOnlyFees(Number(platform_fees_fixed));
                }else{
                    setOnlyFees(Number((((quantity - 1) * fixTicketAmount)*platform_fees)/100));
                }
            } 
        };
      const navigate = useNavigate();
      const sendWhatsAppConfirmation = async (ut_id, ticketDetails) => {
        try {
            const shareableLink = `${window.location.origin}/ticket/view`;
                
            // Get user phone number
            const userDetails = JSON.parse(localStorage.getItem('userDetails'));
            const userPhoneNumber = userDetails.phone;

            // Prepare WhatsApp message payload for backend
            const whatsappPayload = {
                ut_id: ut_id,
                to: userPhoneNumber,
                ticketDetails: ticketDetails,
                shareableLink: shareableLink
            };

            await postRequest("send-whatsapp-confirmation", JSON.stringify(whatsappPayload));
        } catch (error) {
            console.error("Failed to send WhatsApp confirmation:", error);
        }
     };

      const handleBuyTicket = async (ut_id) => {
        try {
            // Prepare ticket details for WhatsApp
            const selectedTicketData = particularEventTicketType.find(
                ticket => ticket.e_t_id === validation1.values.e_t_id
            );
            
            const ticketDetails = {
                eventName: detail.name,
                ticketType: selectedTicketData?.type || 'Ticket',
                quantity: quantity,
                date: validation1.values.selectedDate 
                    ? format(new Date(validation1.values.selectedDate), 'dd MMMM yyyy')
                    : `${format(new Date(detail.start_date), 'dd MMM')} - ${format(new Date(detail.end_date), 'dd MMM yyyy')}`,
                amount: ticketAmount.toFixed(2),
                start_datetime: detail.start_date,
                end_datetime: detail.end_date,
                time: ''
            };

            // Send WhatsApp confirmation
            await sendWhatsAppConfirmation(ut_id, ticketDetails);

            // Navigate to confirmation page
            navigate(`/dashboard/events-details/book-ticket/confirmation/${ut_id}`);
        } catch (error) {
            console.error("Error in handleBuyTicket:", error);
            // Still navigate even if WhatsApp fails
            navigate(`/dashboard/events-details/book-ticket/confirmation/${ut_id}`);
        }
      };

      function formatDateToUTC(dateString) {
        let date = new Date(dateString);
    
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
    
        return new Date(`${year}-${month}-${day}T00:00:00.000Z`).toISOString();
    }

    const [balance, setBalance] = useState("0.00");
    const fetchWalletBalance = async () => {
        setLoading(true);
        const response = await getRequest("user-wallet");
        if (response && response.code === 200) {
            if(response.data[0]){
                setBalance(response.data[0].balance)
            }
            
        } else {
            setAlertData({ variant: "error", message: "Failed to fetch wallet balance" });
            resetAlertData();
        }
    };

      const [formData, setFormData] = useState({
        e_t_id: "",
        selectedDate:""
      });

      const validation1 = useFormik({
        enableReinitialize: true,
    
        initialValues: formData,
        validationSchema: Yup.object({
          e_t_id: Yup.string().required("Plsease select Ticket Type"),
          selectedDate: Yup.string().test(
            "required-if-duration-1",
            "Please select Date",
            function (value) {
              if (duration == 1) {
                return !!value; 
              }
              return true; 
            }
          ),
        }),
    onSubmit: async (values) => {
        // e.preventDefault();

        try {
            if(TokenDetails.guestMode==true){
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: "Please login to purchase the ticket",
                }));
                resetAlertData();
                return;
            }

            if(perTransactionBuyLimit < quantity){
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: `You can only buy a maximum of ${perTransactionBuyLimit} tickets at a time.`,
                }));
                resetAlertData();
                return;
            }

            if(balance>=ticketAmount){
                if(open == false){
                    setOpen(true);
                    return;
                }
            }

            setIsProcessing(true); // Start processing

            if(balance>=ticketAmount){
                setOpen(false);
                const jsonpar = {
                e_id: e_id,
                e_t_id: values.e_t_id,
                quantity: quantity,
                amount: ticketAmount,
                date: values.selectedDate ? (formatDateToUTC(values.selectedDate)) : "",
                platform_fees : onlyFees,
                gst : onlyGst,
                tcs : onlyTcs,
                };
                
                              const validateRes = await postRequest("purchase-ticket-wallet", JSON.stringify(jsonpar));
                              if (validateRes && validateRes.code === 200) {
                                setIsProcessing(false); // Stop processing
                                handleBuyTicket(validateRes.data.ut_id);
                              }
                              else {
                                setAlertData((AlertData) => ({
                                    ...AlertData,
                                    variant: 'error',
                                    message: validateRes.message || "Failed to purchase ticket.",
                                }));
                                resetAlertData();
                                setIsProcessing(false); // Stop processing
                                return;
                            }
            }else{
                
            const referralCode = localStorage.getItem("referralCode") || "";
            const jsonpar = JSON.stringify({
              e_id: e_id,
              e_t_id: values.e_t_id,
              quantity: quantity,
              amount: ticketAmount,
              date: values.selectedDate ? (formatDateToUTC(values.selectedDate)) : "",
              platform_fees : onlyFees,
              gst : onlyGst,
              tcs : onlyTcs,
              referral_code: referralCode
            });

            const res = await postRequest("purchase-ticket-validate", jsonpar);

            if (res && res.code === 200) {
                setFormData({
                  e_t_id: "",
                  selectedDate: "",   
                });
                if (!res.data.id) {
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: res.message || "Failed to purchase ticket.",
                      }));
                      resetAlertData();
                    return;
                }else{
                    let amount = ticketAmount*100;
                    let currency = "INR";
                    var options = {
                        "key": process.env.REACT_APP_RAZORPAY_KEY_ID, 
                        amount,
                        currency,
                        name: "Peacockverse",
                        description: "Ticket Purchase Transaction",
                        order_id: res.data.id, 
                        method: {
                            upi: true 
                        },
                        handler: async function (response) {
                            setIsProcessing(true); // Start processing after payment is successful

                            const body = {
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_order_id: response.razorpay_order_id,
                                razorpay_signature: response.razorpay_signature,
                                e_id: e_id,
                                e_t_id: values.e_t_id,
                                quantity: quantity,
                                amount: ticketAmount,
                                date: values.selectedDate ? (formatDateToUTC(values.selectedDate)) : "",
                                platform_fees : onlyFees,
                                gst : onlyGst,
                                tcs : onlyTcs,
                                adminfees: res.data.adminfees,
                                organizerfees: res.data.organizerfees,
                                organizerfeesbywallet: res.data.organizerfeesbywallet,
                                paid_by_wallet: res.data.paid_by_wallet,
                                paid_by_gateway: res.data.paid_by_gateway,
                                referral_code: referralCode,
                                transaction_id: res.data.transaction_id
                              };

                              const validateRes = await postRequest("purchase-ticket", JSON.stringify(body));
                              if (validateRes && validateRes.code === 200) {
                                setIsProcessing(false); // Stop processing
                                localStorage.setItem("bookfrompopup", false);
                                handleBuyTicket(validateRes.data.ut_id);
                              }
                              else {
                                setAlertData((AlertData) => ({
                                    ...AlertData,
                                    variant: 'error',
                                    message: validateRes.message || "Failed to purchase ticket.",
                                }));
                                resetAlertData();
                                setIsProcessing(false); // Stop processing
                                return;
                            }
                    },
                        prefill: {
                            "contact": TokenDetails.phone
                        },
                        notes: {
                            "transaction_id": res.data.transaction_id,
                            "address": "Razorpay Corporate Office"
                        },
                        theme: {
                            "color": "#3399cc"
                        }
                    };
                    var rzp1 = new window.Razorpay(options);
                    rzp1.on('payment.failed', function (response){
                        setAlertData((AlertData) => ({
                            ...AlertData,
                            variant: 'error',
                            message: response.error.description || "Failed to purchase ticket.",
                          }));
                          resetAlertData();
                        return;
                        // alert(response.error.code);
                        // alert(response.error.description);
                        // alert(response.error.source);
                        // alert(response.error.step);
                        // alert(response.error.reason);
                        // alert(response.error.metadata.order_id);
                        // alert(response.error.metadata.payment_id);
                    });
                    rzp1.open();
                    // e.preventDefault();
                }
            } else {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to purchase ticket.",
                  }));
                  resetAlertData();
            }
            }
        } catch (error) {
            console.log(error)
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: "An error occurred while purchase ticket",
              }));
              resetAlertData();
        }
        finally {
            setIsProcessing(false); // Stop processing in finally block
        }
    }
    });

 
    const [alleventsTicketTypes, setAllEventsTicketTypes] = useState([]);
    const [particularEventTicketType, setParticularEventTicketType] = useState([]);
    const [options, setOptions] = useState([]);
    const [duration, setduration] = useState("");
    const [selectedTicketType, setSelectedTicketType] = useState(); 
    const [totalTickets, setTotalTickets] = useState(0); 

    const handleSelectChangeTicketType = (type) => {
        setQuantity(1);
        validation1.setFieldValue("e_t_id", type.target.value);
        setSelectedTicketType(type.target.value); 

        particularEventTicketType.forEach(element => {
            if(element.e_t_id == type.target.value) {
                setTicketPrice(Number(element.price))
                let ticketamount;
                if(platform_fees_fixed == "Fixed"){
                    ticketamount = Number(element.price) + Number(platform_fees_fixed);
                    setTicketAmount(Number(element.price) + Number(platform_fees_fixed))
                }else{
                    ticketamount = Number(element.price) + Number((element.price * platform_fees)/100);
                    setTicketAmount(Number(element.price) + Number((element.price * platform_fees)/100))
                }
                let onlygst = 0;
                let onlytcs = 0;
                if(detail.gst == true){
                    if(platform_fees_type == "Fixed"){
                        setOnlyGst(Number(((platform_fees_fixed) * gst)/100))
                        onlygst = Number(((platform_fees_fixed) * gst)/100)
                    }else{
                        setOnlyGst(Number(((element.price * platform_fees)/100 * gst)/100))
                        onlygst = Number(((element.price * platform_fees)/100 * gst)/100)
                    }
                }
                if(detail.tcs == true){
                    setOnlyTcs(Number((element.price * tcs)/100))
                    onlytcs = Number((element.price * tcs)/100)
                }
                setTicketAmount(ticketamount+onlygst+onlytcs)
                if(platform_fees_type == "Fixed"){
                    setOnlyFees(Number(platform_fees_fixed));
                }else{
                    setOnlyFees(Number((element.price * platform_fees)/100));
                }
                setFixTicketAmount(element.price)
                setTotalTickets(Number(element.total_tickets) - Number(element.assigned_tickets))
            }
        });
    };

    const handleSelectChangeDuration = (duration) => {
        setQuantity(1);
        setduration(duration.target.value); 

        let eventTicketType = alleventsTicketTypes.filter((type) => type.day_pass == duration.target.value);

        // Auto-fill the selectedDate with start_datetime
        if (duration.target.value === "1") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const startDate = new Date(detail.start_date);
            startDate.setHours(0, 0, 0, 0);
            
            // If start_datetime > today, use start_datetime; otherwise use today + 1
            let dateToUse;
            if (startDate > today) {
                dateToUse = new Date(detail.start_date);
            } else {
                dateToUse = new Date(today);
            }
            
            const dateToUseString = dateToUse.toISOString().split('T')[0];
            
            eventTicketType = eventTicketType.filter((type) => {
                const dayDate = new Date(type.day_date);
                const dayDateString = dayDate.toISOString().split('T')[0];
                return dayDateString === dateToUseString;
            });
            
            validation1.setFieldValue("selectedDate", dateToUse);
        }
        
        setParticularEventTicketType(eventTicketType);

        if (eventTicketType.length > 0) {
            validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
            setSelectedTicketType(eventTicketType[0].e_t_id); 
            setTicketPrice(Number(eventTicketType[0].price))
                let ticketamount;
                if(platform_fees_type == "Fixed"){
                    ticketamount = Number(eventTicketType[0].price) + Number(platform_fees_fixed);
                    setTicketAmount(Number(eventTicketType[0].price) + Number(platform_fees_fixed))
                }else{
                    ticketamount = Number(eventTicketType[0].price) + Number((eventTicketType[0].price * platform_fees)/100);
                    setTicketAmount(Number(eventTicketType[0].price) + Number((eventTicketType[0].price * platform_fees)/100));
                }
                    
                let onlygst = 0;
                let onlytcs = 0;
                if(detail.gst == true){
                    setOnlyGst(Number(((eventTicketType[0].price * platform_fees)/100 * gst)/100))
                    onlygst = Number(((eventTicketType[0].price * platform_fees)/100 * gst)/100)
                    if(platform_fees_type == "Fixed"){
                        setOnlyGst(Number(((platform_fees_fixed) * gst)/100))
                        onlygst = Number(((platform_fees_fixed) * gst)/100)
                    }else{
                        setOnlyGst(Number(((eventTicketType[0].price * platform_fees)/100 * gst)/100))
                        onlygst = Number(((eventTicketType[0].price * platform_fees)/100 * gst)/100)
                    }
                }
                if(detail.tcs == true){
                    setOnlyTcs(Number((eventTicketType[0].price * tcs)/100))
                    onlytcs = Number((eventTicketType[0].price * tcs)/100)
                }
                setTicketAmount(ticketamount+onlygst+onlytcs)
            if(platform_fees_type == "Fixed"){
                setOnlyFees(Number(platform_fees_fixed));
            }else{
                setOnlyFees(Number((eventTicketType[0].price * platform_fees)/100));
            }
            setFixTicketAmount(eventTicketType[0].price);
            setTotalTickets(Number(eventTicketType[0].total_tickets) - Number(eventTicketType[0].assigned_tickets));
        } else {
            validation1.setFieldValue("e_t_id", "");
            setSelectedTicketType("");
            setTicketAmount(0);
            setOnlyFees(0);
            setOnlyGst(0);
            setOnlyTcs(0);
            setFixTicketAmount(0);
            setTotalTickets(0);
        }
    };
  
const pad = (n) => n.toString().padStart(2, '0');
const formatLocalDate = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const handleDateChange = (date) => {
  validation1.setFieldValue("selectedDate", date);

  if (duration === "1" && date) {
    // Convert to YYYY-MM-DD format in LOCAL time
    const selectedDateString = formatLocalDate(date);

    // Filter tickets based on the selected date
    let filteredEventTicketType = alleventsTicketTypes.filter((type) => {
      if (type.day_pass == "1") {
        const dayDate = new Date(type.day_date);
        const dayDateString = formatLocalDate(dayDate);
        return dayDateString === selectedDateString;
      }
      return false;
    });

    setParticularEventTicketType(filteredEventTicketType);

    if (filteredEventTicketType.length > 0) {
      validation1.setFieldValue("e_t_id", filteredEventTicketType[0].e_t_id);
      setSelectedTicketType(filteredEventTicketType[0].e_t_id);
      setTicketPrice(Number(filteredEventTicketType[0].price));
      let ticketamount;
        if(platform_fees_type == "Fixed"){
            ticketamount = Number(filteredEventTicketType[0].price) + Number(platform_fees_fixed);
        }else{
            ticketamount =
            Number(filteredEventTicketType[0].price) +
            Number((filteredEventTicketType[0].price * platform_fees) / 100);
        }

      let onlygst = 0;
      let onlytcs = 0;

      if (detail.gst == true) {
        if(platform_fees_type == "Fixed"){  
            setOnlyGst(Number(((platform_fees_fixed) * gst)/100))
            onlygst = Number(((platform_fees_fixed) * gst)/100)
        }else{
            setOnlyGst(
            Number(
                ((filteredEventTicketType[0].price * platform_fees) / 100) * gst / 100
            )
            );
            onlygst = Number(
            ((filteredEventTicketType[0].price * platform_fees) / 100) * gst / 100
            );
        }
      }
      if (detail.tcs == true) {
        setOnlyTcs(Number((filteredEventTicketType[0].price * tcs) / 100));
        onlytcs = Number((filteredEventTicketType[0].price * tcs) / 100);
      }

      setTicketAmount(ticketamount + onlygst + onlytcs);
      
        if(platform_fees_type == "Fixed"){
            setOnlyFees(Number(platform_fees_fixed));
        }else{
            setOnlyFees(Number((filteredEventTicketType[0].price * platform_fees) / 100));
        }
      setFixTicketAmount(filteredEventTicketType[0].price);
      setTotalTickets(
        Number(filteredEventTicketType[0].total_tickets) -
          Number(filteredEventTicketType[0].assigned_tickets)
      );
    } else {
      // Handle case when no tickets match the criteria
      validation1.setFieldValue("e_t_id", "");
      setSelectedTicketType("");
      setTicketAmount(0);
      setOnlyFees(0);
      setOnlyGst(0);
      setOnlyTcs(0);
      setFixTicketAmount(0);
      setTotalTickets(0);
    }

    // Reset quantity to 1
    setQuantity(1);
  }
};


    // Add helper function to get current day status
    const getCurrentDayStatus = () => {
        // Find the currently selected ticket type from particularEventTicketType
        const selectedTicket = particularEventTicketType.find(
            ticket => ticket.e_t_id === validation1.values.e_t_id
        );
        
        if (selectedTicket) {
            // If tickets are sold out (no tickets available)
            if (Number(selectedTicket.total_tickets) - Number(selectedTicket.assigned_tickets) === 0) {
                return 'sold out';
            }
            // Return the day_status from the selected ticket
            return selectedTicket.day_status;
        }
        
        // Fallback: if no ticket is selected but we have tickets in the list
        if (particularEventTicketType.length > 0 && totalTickets === 0) {
            return 'sold out';
        }
        
        return null;
    };

    const getDayStatusMessage = (status) => {
        switch(status) {
            case 'sold out':
                return {
                    title: "Sold Out",
                    message: "All tickets have been sold out, you can still buy it from secondary market.",
                    color: "#ff4444"
                };
            case 'coming soon':
                return {
                    title: "Coming Soon",
                    message: "Tickets will be available soon",
                    color: "#ff9800"
                };
            default:
                return null;
        }
    };

    const [ticketAmount, setTicketAmount] = useState('0')
    const [fixTicketAmount, setFixTicketAmount] = useState('0')
    const [onlyFees, setOnlyFees] = useState('0')
    const [onlyGst, setOnlyGst] = useState('0')
    const [onlyTcs, setOnlyTcs] = useState('0')
    const [ticketPrice, setTicketPrice] = useState('0')

    const [detail, setDetail] = useState({})
    const [perTransactionBuyLimit, setPerTransactionBuyLimit] = useState(0)
    const fetchEventDetails = async (GST,TCS,posterDetail) => {
        setLoading(true);
        try {
            const response = await getRequest(`event-details/${e_id}`);
            if (response && response.code === 200) {
                const data = response.data;
                // gst/tcs are stored as strings ("true"/"false") in the DB. Normalize
                // them to real booleans so every `data.gst == true` / `data.tcs == true`
                // check below (initial fee calculation) works correctly.
                data.gst = (data.gst === true || data.gst === "true" || data.gst === 1 || data.gst === "1");
                data.tcs = (data.tcs === true || data.tcs === "true" || data.tcs === 1 || data.tcs === "1");
                const { formattedDate, daysCount, time } = formatEventDate(data.start_datetime, data.end_datetime, data.time)
                const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
                setMaxEventDays(calculatedMaxDays);
                setplatform_fees(data.platform_fees_percentage)
                setplatform_fees_fixed(data.platform_fees_fixed)
                setplatform_fees_type(data.platform_fees_type)
                setPerTransactionBuyLimit(data.one_transaction_buy_limit)
                setDetail({
                    name: data.name,
                    event_duration: daysCount,
                    start_date: data.start_datetime,
                    end_date: data.end_datetime,
                    banner: data.banner, 
                    // gst/tcs are stored as strings ("true"/"false"). Normalize to
                    // real booleans so the fee logic's `detail.gst == true` checks work.
                    gst: (data.gst === true || data.gst === "true" || data.gst === 1 || data.gst === "1"), 
                    tcs: (data.tcs === true || data.tcs === "true" || data.tcs === 1 || data.tcs === "1"),
                    status: data.status
                });

                setAllEventsTicketTypes(response.data.eventTicketTypeData);
               
                const eventDate = new Date(data.start_datetime);
                const todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);

                const now = new Date();
                const [starttime, modifier] = (data.start_time).split(" ");
                let [hours, minutes] = starttime.split(":").map(Number);
                if (modifier === "PM" && hours < 12) hours += 12;
                if (modifier === "AM" && hours === 12) hours = 0;
                const compareTime = new Date(now);
                compareTime.setHours(hours, minutes, 0, 0);

                let optionsData=[];
                if (data.one_day_ticket) optionsData.push({ value: "1", label: "Single Day" });
                if (todayDate <= eventDate) {
                    if(todayDate.getDate() === eventDate.getDate()){
                        if (now < compareTime) {
                            if (data.ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });
                        }
                    }else{
                        if (data.ten_day_ticket) optionsData.push({ value: "10", label: "10 Days" });
                    }
                }

                // Check for URL parameters to auto-select day pass
                const urlParams = new URLSearchParams(location.search);
                const dayPassParam = urlParams.get('day_pass');
                
                let selectedDayPass = optionsData.length > 0 ? optionsData[0].value : "";
                
                if(posterDetail.status == "Enable" && posterDetail.e_id == e_id && localStorage.getItem("bookfrompopup") ==  "true"){
                    response.data.eventTicketTypeData.forEach(element => {
                        if(element.e_t_id == posterDetail.e_t_id){
                            selectedDayPass = element.day_pass;
                        }
                    });
                };

                // Override with URL parameter if valid
                if (dayPassParam && optionsData.some(option => option.value === dayPassParam)) {
                    selectedDayPass = dayPassParam;
                }

                if(optionsData.length !==0) {
                    setOptions(optionsData)
                    setduration(selectedDayPass)

                    let eventTicketType = response.data.eventTicketTypeData.filter((type) =>type.day_pass == selectedDayPass);
                    
                    // Additional filter when duration is "1" - filter by day_date matching start_date
                    if (selectedDayPass === "1") {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        
                        const startDate = new Date(data.start_datetime);
                        startDate.setHours(0, 0, 0, 0);

                        // If start_datetime > today, use start_datetime; otherwise use today + 1
                        let dateToUse;
                        if (startDate > today) {
                            dateToUse = new Date(data.start_datetime);
                        } else {
                            dateToUse = new Date(today);
                        }

                        if(posterDetail.status == "Enable" && posterDetail.e_id == e_id && localStorage.getItem("bookfrompopup") ==  "true"){
                            response.data.eventTicketTypeData.forEach(element => {
                                if(element.e_t_id == posterDetail.e_t_id){
                                    const newDate = new Date(element.day_date);
                                    dateToUse = new Date(newDate);
                                }
                            });
                        };

                        const pad = (n) => n.toString().padStart(2, '0');
const formatLocalDate = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;

// after you compute dateToUse:
const dateToUseString = formatLocalDate(dateToUse);
                    
                        // const dateToUseString = dateToUse.toISOString().split('T')[0];
                        eventTicketType = eventTicketType.filter((type) => {
  const dayDate = new Date(type.day_date);
  const dayDateString = formatLocalDate(dayDate);
  return dayDateString === dateToUseString;
});
                        
                        // eventTicketType = eventTicketType.filter((type) => {
                        //     const dayDate = new Date(type.day_date);
                        //     const dayDateString = dayDate.toISOString().split('T')[0];
                        //     return dayDateString === dateToUseString;
                        // });
                        
                        validation1.setFieldValue("selectedDate", dateToUse);
                    }
                    
                    setParticularEventTicketType(eventTicketType);
                    
                    if (eventTicketType.length > 0) {
                        if(posterDetail.status == "Enable" && posterDetail.e_id == eventTicketType[0].e_id && localStorage.getItem("bookfrompopup") ==  "true"){
                            let SpecialTicketTypes = await eventTicketType.filter((type) => {
                                if(type.e_t_id==posterDetail.e_t_id){
                                    return type;
                                }
                            });

                            if(SpecialTicketTypes.length>0){
                                validation1.setFieldValue("e_t_id", SpecialTicketTypes[0].e_t_id);
                                setSelectedTicketType(SpecialTicketTypes[0].e_t_id); 
                                setTicketPrice(Number(SpecialTicketTypes[0].price))
                                let ticketamount;
                                if(data.platform_fees_type == "Fixed"){
                                    ticketamount = Number(SpecialTicketTypes[0].price) + Number(data.platform_fees_fixed);
                                }else{
                                    ticketamount = Number(SpecialTicketTypes[0].price) + Number((SpecialTicketTypes[0].price * data.platform_fees_percentage)/100);
                                }
                                let onlygst = 0;
                                let onlytcs = 0;
                                if(data.platform_fees_type == "Fixed"){
                                    setTicketAmount(Number(SpecialTicketTypes[0].price) + Number(data.platform_fees_fixed));
                                }else{
                                    setTicketAmount(Number(SpecialTicketTypes[0].price) + Number((SpecialTicketTypes[0].price * data.platform_fees_percentage)/100));
                                }
                                
                                if(data.gst == true){
                                    if(data.platform_fees_type == "Fixed"){
                                        setOnlyGst(Number(((data.platform_fees_fixed) * GST)/100))
                                        onlygst = Number(((data.platform_fees_fixed) * GST)/100)
                                    }else{
                                        setOnlyGst(Number((((SpecialTicketTypes[0].price * data.platform_fees_percentage)/100) * GST)/100))
                                        onlygst = Number((((SpecialTicketTypes[0].price * data.platform_fees_percentage)/100) * GST)/100)
                                    }
                                }
                                if(data.tcs == true){
                                    setOnlyTcs(Number(((SpecialTicketTypes[0].price) * TCS * TCS)/100))
                                    onlytcs = Number(((SpecialTicketTypes[0].price) * TCS * TCS)/100)
                                }
                                setTicketAmount(ticketamount+onlygst+onlytcs)

                                if(data.platform_fees_type == "Fixed"){
                                    setOnlyFees(Number(data.platform_fees_fixed));
                                }else{
                                    setOnlyFees(Number((SpecialTicketTypes[0].price * data.platform_fees_percentage)/100));
                                }
                                setFixTicketAmount(SpecialTicketTypes[0].price)
                                setTotalTickets(Number(SpecialTicketTypes[0].total_tickets) - Number(SpecialTicketTypes[0].assigned_tickets))
                            }else{
                                validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
                                setSelectedTicketType(eventTicketType[0].e_t_id); 
                                setTicketPrice(Number(eventTicketType[0].price))
                                let ticketamount;
                                if(data.platform_fees_type == "Fixed"){
                                    ticketamount = Number(eventTicketType[0].price) + Number(data.platform_fees_fixed);
                                }else{
                                    ticketamount = Number(eventTicketType[0].price) + Number((eventTicketType[0].price * data.platform_fees_percentage)/100);
                                }
                                let onlygst = 0;
                                let onlytcs = 0;
                                if(data.platform_fees_type == "Fixed"){
                                    setTicketAmount(Number(eventTicketType[0].price) + Number(data.platform_fees_fixed));
                                }else{
                                    setTicketAmount(Number(eventTicketType[0].price) + Number((eventTicketType[0].price * data.platform_fees_percentage)/100));
                                }
                                
                                if(data.gst == true){
                                    if(data.platform_fees_type == "Fixed"){
                                        setOnlyGst(Number(((data.platform_fees_fixed) * GST)/100))
                                        onlygst = Number(((data.platform_fees_fixed) * GST)/100)
                                    }else{
                                        setOnlyGst(Number((((eventTicketType[0].price * data.platform_fees_percentage)/100) * GST)/100))
                                        onlygst = Number((((eventTicketType[0].price * data.platform_fees_percentage)/100) * GST)/100)
                                    }
                                }
                                if(data.tcs == true){
                                    setOnlyTcs(Number(((eventTicketType[0].price) * TCS * TCS)/100))
                                    onlytcs = Number(((eventTicketType[0].price) * TCS * TCS)/100)
                                }
                                setTicketAmount(ticketamount+onlygst+onlytcs)

                                if(data.platform_fees_type == "Fixed"){
                                    setOnlyFees(Number(data.platform_fees_fixed));
                                }else{
                                    setOnlyFees(Number((eventTicketType[0].price * data.platform_fees_percentage)/100));
                                }
                                setFixTicketAmount(eventTicketType[0].price)
                                setTotalTickets(Number(eventTicketType[0].total_tickets) - Number(eventTicketType[0].assigned_tickets))
                            }
                        }else{
                            validation1.setFieldValue("e_t_id", eventTicketType[0].e_t_id);
                            setSelectedTicketType(eventTicketType[0].e_t_id); 
                            setTicketPrice(Number(eventTicketType[0].price))
                            let ticketamount;
                            if(data.platform_fees_type == "Fixed"){
                                ticketamount = Number(eventTicketType[0].price) + Number(data.platform_fees_fixed);
                            }else{
                                ticketamount = Number(eventTicketType[0].price) + Number((eventTicketType[0].price * data.platform_fees_percentage)/100);
                            }
                            let onlygst = 0;
                            let onlytcs = 0;
                            if(data.platform_fees_type == "Fixed"){
                                setTicketAmount(Number(eventTicketType[0].price) + Number(data.platform_fees_fixed));
                            }else{
                                setTicketAmount(Number(eventTicketType[0].price) + Number((eventTicketType[0].price * data.platform_fees_percentage)/100));
                            }
                            
                            if(data.gst == true){
                                if(data.platform_fees_type == "Fixed"){
                                    setOnlyGst(Number(((data.platform_fees_fixed) * GST)/100))
                                    onlygst = Number(((data.platform_fees_fixed) * GST)/100)
                                }else{
                                    setOnlyGst(Number((((eventTicketType[0].price * data.platform_fees_percentage)/100) * GST)/100))
                                    onlygst = Number((((eventTicketType[0].price * data.platform_fees_percentage)/100) * GST)/100)
                                }
                            }
                            if(data.tcs == true){
                                setOnlyTcs(Number(((eventTicketType[0].price) * TCS * TCS)/100))
                                onlytcs = Number(((eventTicketType[0].price) * TCS * TCS)/100)
                            }
                            setTicketAmount(ticketamount+onlygst+onlytcs)

                            if(data.platform_fees_type == "Fixed"){ 
                                setOnlyFees(Number(data.platform_fees_fixed));
                            }else{
                                setOnlyFees(Number((eventTicketType[0].price * data.platform_fees_percentage)/100));
                            }
                            setFixTicketAmount(eventTicketType[0].price)
                            setTotalTickets(Number(eventTicketType[0].total_tickets) - Number(eventTicketType[0].assigned_tickets))
                        }
                    
                    } else {
                        validation1.setFieldValue("e_t_id", "");
                        setSelectedTicketType("");
                        setTicketAmount(0);
                        setOnlyFees(0);
                        setOnlyGst(0);
                        setOnlyTcs(0);
                        setFixTicketAmount(0);
                        setTotalTickets(0);
                    }
                } else {
                    setAlertData({ variant: "error", message: "Tickets are not available" });
                }
                
            } else {
                setAlertData({ variant: "error", message: response.message || "Failed to fetch event details" });
            }
        } catch (error) {
            setAlertData({ variant: "error", message: "Something went wrong!" });
        }
        setLoading(false);
        resetAlertData();
    };

    const [platform_fees, setplatform_fees] = useState();
    const [platform_fees_fixed, setplatform_fees_fixed] = useState();
    const [platform_fees_type, setplatform_fees_type] = useState();


    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };

    const [gst, setGst] = useState();
    const [tcs, setTcs] = useState();
    const fetchSettings = async (posterDetail) => {
    setLoading(true);
    const response = await getRequest("site-settings");
    if (response && response.code === 200) {
      let GST = 0;
      let TCS = 0;
      response.data.forEach(element => {
        if(element.setting_name == "gst"){
            setGst(element.setting_value);
            GST = element.setting_value;
        }
        if(element.setting_name == "tcs"){
            setTcs(element.setting_value);
            TCS = element.setting_value;
        }
      });
        fetchEventDetails(GST,TCS,posterDetail);
      
    } else {
      setAlertData({ variant: "error", message: "Failed to fetch settings" });
      resetAlertData();
    }
    setLoading(false);
  };

    // Check if user is logged in
    const checkUserLoggedIn = () => {
      const TokenDetails = JSON.parse(localStorage.getItem('userDetails'));
      return TokenDetails && !TokenDetails.guestMode;
    };
    
    const fetchPoster = async () => {
    const response = await getRequest("poster");
    if (response && response.code === 200) {

      fetchSettings(response.data);
    } else {
      console.error("Failed to fetch poster:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "error",
        message: "Failed to fetch poster",
      }));
    }
    resetAlertData();
  };

    // Show login modal on page load if user is not logged in
    useEffect(() => {
        const fullUrl = window.location.pathname + window.location.search;
        localStorage.setItem("redirectAfterLogin", fullUrl);
        if (!checkUserLoggedIn()) {
            setShowLoginModal(true);
        }
        else {
            fetchWalletBalance();
            fetchPoster();
        }
    }, []);

        // Helper: currently selected ticket object (by selected e_t_id)
        const selectedTicketObj = particularEventTicketType.find(
                (ticket) => ticket.e_t_id === validation1.values.e_t_id
        ) || null;

        // Helper: return the best available time string for the selected ticket
        const getSelectedTicketTime = () => {
                if (selectedTicketObj) {
                        if (selectedTicketObj.time) return selectedTicketObj.time;
                }
                if (detail && detail.time) return detail.time;
                return null;
        };

        if (!detail) return <Typography>No ticket details found.</Typography>;

    return (
        <Box sx={{ flexGrow: 1 }}>
            {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
            
            {/* Add Login Modal */}
            <LoginModal 
              open={showLoginModal} 
              onClose={() => setShowLoginModal(false)}
              onLoginSuccess={() => setShowLoginModal(false)}
            />
            
            <Grid2 className="center-App" container direction="column">
                <Grid2 className='header_details' height={"221px"} sx={{ backgroundImage: `url("${detail.banner ? detail.banner : banner}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <Grid2 className='menu-Link' component={Link}  to={`/dashboard/events-details/${e_id}`}  style={{ cursor: 'pointer', opacity: 1 }}>
                        <img src={BackImage} alt="Navbar" width={180} />
                    </Grid2>
                    <Typography className='categories-name'>Book Ticket</Typography>
                    <Grid2 className="back-shadow-img"></Grid2>
                </Grid2>
                {loading ? (
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", minHeight: "300px" }}>
                        <CircularProgress color="primary" />
                        <p>Loading ...</p>
                    </Box>
                ) : (
                <Box sx={{ padding: '15px 15px', float: 'left', width: '100%' }}>
                    <Grid2 container spacing={2}>
                         <Grid2 item xs={12} sx={{ float: 'left', width: '100%' }}>
                                <Grid2 className="events-time"> <Typography sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}>{maxEventDays}  Day's Event</Typography></Grid2>
                            {/* <Grid2 className='events-time'><Typography sx={{ fontWeight: 500, color: "#6638A2", fontSize: "19px" }}>{daysCount} Day's Event</Typography></Grid2> */}
                            <Typography variant="h2" className='title' sx={{ marginBottom: '-5px', fontSize: "32px", marginTop: "20px", color: "#6638A2", fontWeight: "500" }}>{detail.name}</Typography>
                        </Grid2>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Grid2 item xs={12} className="fullWidth" sx={{ marginTop: "12px" }}>
                                    <Typography variant="h4" className='title'>Ticket Information</Typography>
                                    
                                </Grid2>
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth className='custom-select dropdown'>
                                    <Typography className='lable-title'>Event Day's</Typography>
                                    <Select labelId="" id="" value={duration} name="duration"  onChange={handleSelectChangeDuration}>
                                    {options.map((option) => (
                                    <MenuItem value={option.value}>{option.label}</MenuItem>
                                    ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={6}>
                            <FormControl fullWidth className='custom-select dropdown'>
                                    <Typography className='lable-title'>Select Ticket</Typography>
                                    <Select labelId="" id="" value={validation1.values.e_t_id} name="e_t_id" onChange={handleSelectChangeTicketType}>
                                    {particularEventTicketType.map((ticketTypes) => (
                                        <MenuItem value={ticketTypes.e_t_id}>{ticketTypes.type}</MenuItem>
                                    ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Show selected ticket time (if available) */}
                            {getSelectedTicketTime() ? (
                                <Grid item xs={12}>
                                    <FormControl fullWidth className='custom-select'>
                                        <Typography className='lable-title'>Ticket Time</Typography>
                                        <Typography variant="body1" sx={{ color: '#341439' }}>{getSelectedTicketTime()}</Typography>
                                    </FormControl>
                                </Grid>
                            ) : null}

                            {duration==1?
                                <Grid item xs={12}>
                                <FormControl fullWidth className='custom-select datepciker'>
                                    <Typography className='lable-title'>Select Date</Typography>
                                    <DatePicker 
                                        className={`form-control ${validation1.touched.selectedDate && validation1.errors.selectedDate ? "is-invalid" : ""}`} 
                                        inputMode="none" 
                                        isClearable id="date-picker"  
                                        name="selectedDate" 
                                        selected={validation1.values.selectedDate} 
                                        onChange={handleDateChange} 
                                        dateFormat="dd-MM-yyyy" 
                                        placeholderText="DD-MM-YYYY" 
                                        format="DD/MM/YYYY" 
                                        minDate={new Date(Math.max(new Date().setHours(0, 0, 0, 0), new Date(detail.start_date)))}
                                        maxDate={new Date(detail.end_date)}
                                        autoComplete="off"
                                        disableKeyboardNavigation
                                    />
                                    {validation1.touched.selectedDate && validation1.errors.selectedDate && (
                                        <Typography className='lable-error'>{validation1.errors.selectedDate}</Typography>
                                    )}
                                </FormControl>
                                </Grid>
                                :""
                            }

                            <Grid item xs={12}>
                                <FormControl fullWidth className='custom-quantity'>
                                    <Typography className='lable-title'>Quantity</Typography>
                                    <Box display="flex" alignItems="center" justifyContent="center" border={1} borderRadius={4} overflow="hidden">
                                        <Button onClick={handleDecrement}><img src={Minus} alt='' /></Button>
                                        <Typography variant="body1" sx={{ flex: 1, textAlign: 'center', padding: '8px', backgroundColor: 'rgba(128, 0, 128, 0.1)', color: 'purple' }}>{String(quantity).padStart(2, '0')}</Typography>
                                        <Button onClick={handleIncrement}><img src={Plus} alt='' /></Button>
                                    </Box>
                                </FormControl>
                            </Grid>

                        {totalTickets > 0 && getCurrentDayStatus() !== 'sold out' && getCurrentDayStatus() !== 'coming soon' && detail.status !== "Disable" ?
                        <>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                        }}
                                    >
                                        Ticket Price :
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                        }}
                                    >
                                        ₹{Number(ticketPrice.toFixed(2))}
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} style={{ paddingTop: "5px" }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "16px",
                                        color: "#341439",
                                    }}
                                >
                                    Platform Fees :
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "16px",
                                        color: "#341439",
                                    }}
                                >
                                    ₹{onlyFees.toFixed(2)}
                                </Typography>
                            </Box>
                            </Grid>

                            {detail.gst == true?
                                <Grid item xs={12} style={{ paddingTop: "5px" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                        }}
                                    >
                                        GST :
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                        }}
                                    >
                                        ₹{onlyGst.toFixed(2)}
                                    </Typography>
                                </Box>
                                </Grid>
                            :""}
                            
                            {detail.tcs == true?
                                <Grid item xs={12} style={{ paddingTop: "5px" }}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: "16px",
                                                color: "#341439",
                                            }}
                                        >
                                            TCS :
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontSize: "16px",
                                                color: "#341439",
                                            }}
                                        >
                                            ₹{onlyTcs.toFixed(2)}
                                        </Typography>
                                    </Box>
                                </Grid>
                            :""}
                          

                            <Grid item xs={12} style={{ paddingTop: "5px" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Total Amount :
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontSize: "16px",
                                            color: "#341439",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        ₹{ticketAmount.toFixed(2)}
                                    </Typography>
                                </Box>
                            </Grid>
                        </>
                        :""
                        }
                        </Grid>
                        
                    </Grid2>
                    
                    {totalTickets > 0 && getCurrentDayStatus() !== 'sold out' && getCurrentDayStatus() !== 'coming soon' && detail.status !== "Disable" ? 
                        
                    <Grid className='button-bottom fullWidth' fullWidth>
                        <Button
                            type='submit'
                            className='btn-common'
                            variant="contained"
                            color="primary"
                            fullWidth
                            disabled={isProcessing}
                            onClick={(e) => {
                                e.preventDefault();
                                validation1.handleSubmit();
                                return false;
                            }}
                            sx={{
                                '&.Mui-disabled': {
                                    color: 'white',
                                    backgroundColor: '#7B47F5',
                                    opacity: 0.7,
                                },
                            }}
                            >
                            {isProcessing ? "PROCESSING..." : `Book Ticket ₹${ticketAmount.toFixed(2)}`}
                        </Button>
                    </Grid>
                    :
                    detail.status === "Disable" ?
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    backgroundColor: '#ff444420',
                                    border: `2px solid #ff4444`,
                                    borderRadius: '12px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    marginTop: '20px'
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: '#ff4444',
                                        fontWeight: 'bold',
                                        marginBottom: '8px',
                                        fontSize: '24px'
                                    }}
                                >
                                    Event Currently Unavailable
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: '#666',
                                        fontSize: '16px'
                                    }}
                                >
                                    The event has been disabled and cannot be booked right now. Please check back later.
                                </Typography>
                            </Box>
                        </Grid>
                    :
                    getCurrentDayStatus() && (getCurrentDayStatus() === 'sold out' || getCurrentDayStatus() === 'coming soon') ?
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    backgroundColor: getDayStatusMessage(getCurrentDayStatus())?.color + '20',
                                    border: `2px solid ${getDayStatusMessage(getCurrentDayStatus())?.color}`,
                                    borderRadius: '12px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    marginTop: '20px'
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: getDayStatusMessage(getCurrentDayStatus())?.color,
                                        fontWeight: 'bold',
                                        marginBottom: '8px',
                                        fontSize: '24px'
                                    }}
                                >
                                    {getDayStatusMessage(getCurrentDayStatus())?.title}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: '#666',
                                        fontSize: '16px'
                                    }}
                                >
                                    {getDayStatusMessage(getCurrentDayStatus())?.message}
                                </Typography>
                            </Box>
                        </Grid>
                    : null
                    }
                </Box>
                )}
            </Grid2>
                  <Dialog open={open} onOpenChange={setOpen}>
                    <div
                      className="install-modal"
                      style={{
                        zIndex: 111,
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          background: "white",
                          padding: "25px 10px 30px",
                          borderRadius: "10px",
                          textAlign: "center",
                          width: "100%",
                          maxWidth: "430px",
                          margin: "0 10px",
                        }}
                      >
                        <p style={{ fontSize: "20px", marginTop: "8px" }}>
                          Wallet Balance :  {balance} Rs
                        </p>
                        <p style={{ fontSize: "20px", marginTop: "8px" }}>
                          Are you sure you want book ticket?
                        </p>
                        <button
                          id="submit1"
                          onClick={(e) => {
                            e.preventDefault();
                            validation1.handleSubmit();
                            return false;
                          }}
                          style={{
                            background: "#6638A2",
                            border: "none",
                            padding: "4px 25px",
                            fontSize: "18px",
                            color: "#fff",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                        >
                          Book
                        </button>
                        <button
                          onClick={() => setOpen(false)}
                          style={{
                            marginLeft: "10px",
                            background: "#EFEFEF",
                            border: "none",
                            padding: "4px 25px",
                            fontSize: "18px",
                            borderRadius: "5px",
                            cursor: "pointer",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Dialog>
        </Box>
    );
};

export default Eventsticketbook;